import posts from './posts.json';

/* Post metadata (title, description, date, image, EN<->ES pairing) lives in
   posts.json so the build scripts (gen-sitemap, prerender) read the same list.
   Bodies are markdown strings in ./<lang>/<slug>.js and are loaded on demand:
   webpack gives each post its own chunk, so the homepage and the blog index
   don't download every article. */
Object.values(posts).forEach(list =>
  list.sort((a, b) => b.date.localeCompare(a.date))
);

export const loadBody = (lang, slug) =>
  import(`./${lang}/${slug}.js`).then(m => m.default);

export const formatPostDate = (date, lang) =>
  new Date(date).toLocaleDateString(lang === 'es' ? 'es-419' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    // Dates are plain YYYY-MM-DD, which parses as UTC midnight; without this
    // visitors west of UTC would see the previous day.
    timeZone: 'UTC',
  });

export default posts;
